export default [
  {
    header: 'reply.menu-title',
  },
  {
    title: 'reply.menu-add',
    route: 'owner:posts',
    icon: 'MessageCircleIcon',
  },
  {
    title: 'reply.menu-enabled',
    route: 'owner:reports',
    icon: 'ListIcon',
  },
  {
    title: 'reply.menu-templates',
    route: 'owner:reply-templates',
    icon: 'MenuIcon',
  },
  {
    title: 'reply.menu-comment-templates',
    route: 'owner:comment-templates',
    icon: 'MessageSquareIcon',
  },
]
